export default __webpack_public_path__ + "static/media/59.7462d71b.png";